import { fetchStories } from '../../helpers/api/story';

const { createSlice } = require('@reduxjs/toolkit');

const storySlice = createSlice({
    name: 'story',
    initialState: {
        stories: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStories.fulfilled, (state, action) => {
                state.loading = false;
                state.stories = action.payload;
            })
            .addCase(fetchStories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Something went wrong';
            })
    },
});
export default storySlice.reducer;
